module.exports = __webpack_public_path__ + "assets/images/plannerRemoveControlPoints-45a2a93e2a850aa5839e804d6b546374.gif";